import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import GridList from '@material-ui/core/GridList';

// app: components
import Button from 'components/Button';

// constants
import { BREAKPOINTS } from 'constants/index';

const DEFAULT_COLUMNS = 4;

const Grid = React.forwardRef((props, ref) => {
  const {
    children,
    className,
    columns,
    itemWidth,
    justify,
    mobileClassName,
    mobileView,
    onShowMore,
    showMore,
    width,
  } = props;
  const isMobile = width <= BREAKPOINTS.PHONE_VERTICAL;

  // Display as many tiles as will fit
  // If for some reason the width is not known then just display 4.
  const colsBasedOnFit = Math.floor(width / itemWidth) || DEFAULT_COLUMNS;
  const cols = columns ? Math.min(colsBasedOnFit, columns) : colsBasedOnFit;

  // pad out any overflow so that the tiles arrange nicely
  const tiles = [...children];

  if (tiles.length > cols) {
    while (tiles.length % cols !== 0) {
      tiles.push(<div key={`placeholder-${tiles.length}`} className="content-items__item" />);
    }
  }
  const showMoreButton = showMore ? (
    <div className="content-items__show-more">
      <Button themeName="energized" themeType="clear" size="large" onClick={onShowMore}>
        Show More
      </Button>
    </div>
  ) : null;

  if (isMobile && mobileView === 'list') {
    return (
      <div ref={ref}>
        <ul className={mobileClassName}>{children}</ul>
        {showMoreButton}
      </div>
    );
  }

  const gridWidth = cols * itemWidth + itemWidth / 2;
  return (
    <div ref={ref}>
      <div className={className}>
        <GridList
          cols={cols}
          cellHeight="auto"
          className="content-items__grid"
          style={{ justifyContent: justify, maxWidth: gridWidth }}
        >
          {tiles}
        </GridList>
      </div>
      {showMoreButton}
    </div>
  );
});

Grid.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  className: PropTypes.string,
  columns: PropTypes.number,
  mobileClassName: PropTypes.string,
  onShowMore: PropTypes.func,
  itemWidth: PropTypes.number,
  justify: PropTypes.string,
  mobileView: PropTypes.oneOf(['grid', 'list']),
  showMore: PropTypes.bool,
  width: PropTypes.number,
};

Grid.defaultProps = {
  className: null,
  columns: null,
  mobileClassName: null,
  onShowMore: () => {},
  itemWidth: 256,
  justify: null,
  mobileView: 'list',
  showMore: true,
  width: 800,
};

export default Grid;
